import React from "react";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import ScrollingResize from "./ScrollingResize";
import HeaderSearchBar from "core/SearchBar/variations/HeaderSearchBar";

// styles
import { convertPxToRem } from "frontend/components/helpers";

const Row2Styled = styled.div`
    position: relative;
    margin-top: ${({ $marginTop }) => convertPxToRem($marginTop)};
    height: ${({ $height }) => convertPxToRem($height)};
    overflow: ${({ $isVisible }) => ($isVisible ? "visible" : "hidden")};
`;

// component
export const Row2 = () => {
    const {
        isDarkMode,
        animation: { overflow },
        header: { secondRowHeight, secondRowMarginTop }
    } = useSiteHeader();

    return (
        <Row2Styled
            $isVisible={overflow.isVisible}
            $height={secondRowHeight}
            $marginTop={secondRowMarginTop}
        >
            <ScrollingResize>
                <HeaderSearchBar
                    id="header-search-mobile"
                    isDarkMode={isDarkMode}
                />
            </ScrollingResize>
        </Row2Styled>
    );
};

export default Row2;
